import { IAppState } from '../../redux';
import { EFairPlayStatus } from '../../redux/reducers';

export function selectFairPlayStatus(state: IAppState): EFairPlayStatus {
  const {
    fairPlay: { status },
  } = state;

  return status;
}
